import './App.css';
import * as AuthAPI from './services/authAPI';
import AuthContext from './context/AuthContext';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SetPasswordPage from './pages/SetPasswordPage';
import { useState } from 'react';
import Navbar from './components/Navbar';
import VehiclesPage from './pages/VehiclesPage';
import VehiclePage from './pages/VehiclePage';
import ProfilePage from './pages/ProfilePage';
import TicketsPage from './pages/TicketsPage';
import TicketPage from './pages/TicketPage';
import Page404 from './pages/Page404';

function App() {

    const navigate = useNavigate();

    const tokenData = AuthAPI.setup();
    const [isAuthenticated, setIsAuthenticated] = useState(AuthAPI.isAuthenticated());
    const [role, setRole] = useState(tokenData?.role ?? null);

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            setIsAuthenticated,
            role,
            setRole
        }}>
            <div className="App">
                {isAuthenticated && <Navbar role={role} />}
                <div className={`main-content flex-grow-1${isAuthenticated ? ' with-bottom-bar' : ''}`}>
                    <div className="container-fluid p-4">
                        <Routes>
                            <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <LoginPage navigate={navigate} />} />
                            <Route path="/forgot-password" element={<ForgotPasswordPage navigate={navigate} />} />
                            <Route path="/reset-password" element={<SetPasswordPage navigate={navigate} mode="reset" />} />
                            <Route path="/register" element={<SetPasswordPage navigate={navigate} mode="invitation" />} />
                            <Route element={<PrivateRoute />}>
                                <Route path="/" element={<Navigate to="/vehicles" />} />
                                <Route path="/vehicles" element={<VehiclesPage />} />
                                <Route path="/vehicles/:id" element={<VehiclePage />} />
                                {role === "ROLE_FLEET_MANAGER" && (
                                    <>
                                        <Route path="/tickets" element={<TicketsPage />} />
                                        <Route path="/tickets/:id" element={<TicketPage />} />
                                    </>
                                )}
                                <Route path="/profile" element={<ProfilePage />} />
                            </Route>
                            <Route path="*" element={<Page404 />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </AuthContext.Provider>
    )
}

export default App;
